module.exports = {
  "Gattaran_MSGCenter__CDEL": "Instructions for Message Integration",
  "Gattaran_Feedback__gRVu": "Up to 1 non-image attachment can be uploaded",
  "Gattaran_V2_wZWG_RFvr": "Upload Target Group",
  "Gattaran_Homepage__SgjR": "Permissions List",
  "Gattaran_Homepage__nRqe": "No visit history",
  "Gattaran_Feedback__vYiO": "Please select",
  "common_yes": "Yes",
  "Gattaran_MSGCenter__fKLA": "Please select",
  "Gattaran_Feedback__bpPs": "Issue Description",
  "Gattaran_Feedback__QLll": "Gattaran Feature Module for Issue Occurrence",
  "Gattaran_V2_FXzs_ylzm": "Submit for Review",
  "Gattaran_V2_aQes_enLD": "Description",
  "Gattaran_MSGCenter__JYjL": "Please enter",
  "Gattaran_Feedback__TtBS": "Page Link of Issue Occurrence",
  "Gattaran_Feedback__zEDP": "Image Attachments (up to 5 images, not larger than 5MB each)",
  "Gattaran_Feedback__AOcA": "Submitter",
  "Gattaran_MSGCenter__rsFg": "Delete",
  "Gattaran_MSGCenter__jECw": "Send via business integration",
  "Gattaran_Feedback__auMY": "View",
  "Gattaran_MSGCenter__mzAm": "Notifications",
  "Gattaran_MSGCenter__esKt": "Enter message title keyword",
  "Gattaran_system_KMzx_LdcE": "The feedback has been submitted to the Lean backend for processing. You can track the progress using this link",
  "Gattaran_Homepage__Ntsj": "For assistance, please contact: {{pm_name}}",
  "Gattaran_MSGCenter__YFIH": "ID",
  "Gattaran_Feedback__zikb": "You can check the \"My Feedback\" list to view feedback processing progress",
  "FoodB_up250108_UBUH_aRBX": "Please set pop-up countdown",
  "Gattaran_Homepage__qJVu": "Links to My Requests, My Roles, and My audit have been moved here",
  "Gattaran_V2_tuhT_AOTp": "Send periodically",
  "Gattaran_V2_qdkl_zhnr": "Maximum",
  "Gattaran_V2_elkQ_uPKA": "time(s)",
  "Gattaran_20240401_cZwR_udOc": "Survey Details",
  "Gattaran_V2_DECM_uvLB": "Link button name (default display: {{default}})",
  "sailing.dilu.myfeedback": "My Feedback",
  "Gattaran_V2_crhT_oxkz": "Under Review",
  "Gattaran_Feedback_aLLw_KcWa": "Technical Consultation",
  "Gattaran_Feedback__EAYk": "ID",
  "Gattaran_Homepage__IEfB": "Recently Visited displays the features you have recently visited. It is a quick access entry.",
  "soda-b-web-i18n---加载中": "Loading...",
  "Gattaran_Homepage__HleZ": "The following roles have permissions for this page:",
  "Gattaran_Feedback__MQam": "Degree of Urgency",
  "Gattaran_MSGCenter__GFMl": "Targeted Recipients",
  "Gattaran_Homepage__TQJz": "The current page is not integrated into the new version of Gattaran. To access this page, please click the button below.",
  "Gattaran_Homepage__HCuT": "Main Navigation Bar",
  "Gattaran_MSGCenter__buje": "Create",
  "Gattaran_V2_uXMx_qica": "Download Template",
  "Gattaran_MSGCenter__Nbaz": "Start Date",
  "Gattaran_Feedback_PXop_Eszz": "Operations Assistance",
  "Gattaran_MSGCenter__yaaT": "Message Link",
  "Gattaran_MSGCenter__SAQd": "Effective Period",
  "Gattaran_Feedback__IdvX": "Additional Attachment (Excel, pdf, Word; only 1)",
  "Gattaran_Feedback__RCjf": "Create new feedback",
  "Gattaran_MSGCenter__jnGI": "Content Settings",
  "Gattaran_Feedback_jzdw_zMgo": "I may have found a technical bug",
  "Gattaran_Feedback__dglB": "Issue Description",
  "Gattaran_Feedback_LxIv_wsSj": "I have a feature request/suggestion",
  "Gattaran_Feedback__eNEw": "Region of Issue Occurrence",
  "Gattaran_Feedback__Xbej": "High",
  "FoodOpD_tools_Original_file_QXqs": "Download Original File",
  "Gattaran_Feedback_aSQV_CWCu": "What do you need help with?",
  "FoodD_one_Try_again_qZka": "Try Again",
  "Gattaran_MSGCenter__ZPZZ": "Title Keyword",
  "Gattaran_20240401_BAMn_cVoR": "‘Select Multiple’ questions must contain at least two options",
  "soda-t-i18n---确定": "Confirm",
  "Gattaran_Feedback_yoej_DTPb": "I need support from the tech team",
  "Gattaran_V2_OAkm_oSIp": "The end level product module in the options will be shown as the message sender in Gattaran Message Center",
  "Gattaran_20240401_heKh_sVNg": "Required?",
  "Gattaran_MSGCenter__HjTW": "Send via message center backend",
  "Gattaran_MSGCenter__PvCm": "Send Time",
  "Gattaran_Feedback__fRJi": "Medium",
  "Gattaran_Feedback__dOJj": "Low",
  "Gattaran_MSGCenter__MWqV": "Search",
  "Gattaran_MSGCenter__imft": "Up to one image can be uploaded",
  "Gattaran_Feedback__JuAw": "Processing conclusion was submitted successfully, and feedback status was changed to \"Completed\"",
  "Gattaran_Auth_dmRq_HvpZ": "Can’t use this feature?",
  "Gattaran_Homepage__Hjbo": "Contact Us",
  "Gattaran_Feedback_FAZM_REhE": "I want to learn how to use this feature",
  "取消": "Cancel",
  "Gattaran_MSGCenter__qJkV": "Active",
  "Gattaran_20240401_Dqdw_zVjj": "Are you sure you want to launch this survey?",
  "Gattaran_V2_wQRP_UYwo": "Reviewer",
  "Gattaran_MSGCenter__iuwu": "Enter ID",
  "Gattaran_20240401_ycgC_XryN": "Survey Center",
  "Gattaran_Feedback__EhcV": "Feedback Info",
  "FoodOpC_gattaran_Enter_CWSB": "Enter text here",
  "Gattaran_20240401_SptO_OiTm": "Character limit exceeded",
  "Gattaran_20240401_dWRX_PBUn": "Survey Type",
  "Gattaran_MSGCenter__kLtS": "End Date",
  "Gattaran_Homepage__ybCE": "On the home page, you can view an overview of the Gattaran system",
  "Gattaran_Feedback_oHQm_chDu": "Please join the D-Chat group below to share the details so that the Ops Team can assist you",
  "Gattaran_Feedback__lQre": "Submitter",
  "Gattaran_MSGCenter__AjjW": "Send at specified time",
  "Gattaran_V2_ayrB_ekxC": "Cover image (aspect ratio: 3:1, suggested width: >800px)",
  "Gattaran_MSGCenter__vrnW": "View Details",
  "Gattaran_Homepage__YscW": "More",
  "Gattaran_Homepage__ssGO": "Missing permission: {{node_info}}",
  "Gattaran_Feedback__HTsy": "Submit",
  "Gattaran_Feedback__urHD": "Low",
  "Gattaran_MSGCenter__KgwQ": "Launch",
  "Gattaran_MSGCenter__UnwR": "Create",
  "Gattaran_Homepage__DMWj": "RD Integration Manual",
  "Gattaran_Feedback__cLbb": "Medium",
  "Gattaran_Feedback_NvwL_Uxho": "I need other operations support",
  "Gattaran_V2_Tzot_kaOW": "Message Center Manual (For PM/RD/PO)",
  "Gattaran_MSGCenter__pUdp": "Message Details",
  "Gattaran_V2_jXfh_Bzau": "Please set “Time Zone Selection” first",
  "Gattaran_Feedback_baMd_rUqS": "Menu change request",
  "Gattaran_DataPortal__aqBh": "STAR(Data Portal)",
  "Gattaran_20240401_bAxu_VxZT": "Respondents",
  "DiDi_Food_(C)_Customer_automatically_apply_Add_ZyML": "Add",
  "Gattaran_MSGCenter__jcAm": "Please select",
  "Gattaran_Feedback_UUdB_fdYt": "I have a task pending review",
  "Gattaran_Feedback__qGnl": "Feedback was submitted to Product PoC {{pm_name}}",
  "Gattaran_20240401_cSnz_WMLD": "Select multiple",
  "Gattaran_20240401_iuEu_VEPo": "Rating question (10-point scale)",
  "Gattaran_alert_zVGm_gOUV": "New version data is available. Refresh to get the latest content",
  "Gattaran_0411_MWuz_zfQj": "Placement Location",
  "Gattaran_MSGCenter__wEBm": "No messages",
  "Gattaran_Homepage__XHuN": "A collection of basic Gattaran feature settings, including tasks, review, message configuration, and feedback.",
  "Gattaran_Homepage__ktsW": "Confirm",
  "Gattaran_Feedback__OHxt": "Feedback",
  "Gattaran_Homepage__vkPG": "Click the Group Link to join",
  "Gattaran_Homepage__yTjZ": "You do not have permission to access this page",
  "Gattaran_MSGCenter__tcGJ": "Send Method",
  "Gattaran_MSGCenter__tOPK": "Description of Purpose",
  "Gattaran_MSGCenter__mwuC": "Message Title",
  "Gattaran_MSGCenter__jtwt": "Created at",
  "FoodOpB_Gattaran_Edit_dTpu": "Edit",
  "Gattaran_V2_uLPb_Hgku": "Custom group",
  "Gattaran_V2_pLhS_NyGm": "Messages sent via backend configuration",
  "Gattaran_20240401_Dror_RtHt": "Question Type",
  "soda-t-i18n---取消": "cancel",
  "Gattaran_Feedback__LtzD": "Feedback",
  "Gattaran_20240401_mhox_xExM": "Please enter the question description",
  "Gattaran_20240401_gZfx_mUCE": "Once this survey is launched, it will be forcibly shown as a pop-up in the BD app which cannot be closed. Are you sure you want to launch this survey?",
  "Gattaran_lowcode_dTZL_JDSp": "A new window has opened. Please view it in your browser.",
  "Gattaran_Feedback__KBWX": "Status Update Time",
  "soda-d-i18n---下载": "download",
  "Gattaran_Feedback__HgXn": "Start Processing",
  "Gattaran_Feedback__ZHEu": "Reason for Feedback",
  "Gattaran_Homepage__VxjE": "Toolbar",
  "Gattaran_MSGCenter__NWqi": "View",
  "Gattaran_20240401_EyCp_urep": "Select one",
  "Gattaran_Feedback__yvfR": "Cancel",
  "Gattaran_Feedback__amKQ": "High",
  "Gattaran_MSGCenter__xZzf": "Effective Period",
  "Gattaran_Homepage__dzQv": "No role permissions have been associated with this feature yet",
  "Gattaran_20240401_BIfp_ZYiB": "Rating question (5-point scale)",
  "Gattaran_20240401_gSOw_DugT": "{{research_num}} surveys have been added to the BD app homepage in the last 30 days. Too many surveys could interrupt the daily work of BDs. Are you sure you want to launch this survey?",
  "FoodB_up250108_fBFI_ZRnR": "Pop-up Countdown (Caution: This prevents users from closing the window for up to 10s)",
  "Gattaran_lowcode_axmA_FvoV": "Unable to get URL. Please click to try again, or contact the platform administrator.",
  "Gattaran_Homepage__YLig": "Link Exchange",
  "Gattaran_MSGCenter__PuUe": "Loading…",
  "Gattaran_Feedback__EqVZ": "Degree of Urgency",
  "Gattaran_Homepage__upog": "Welcome to Gattaran",
  "Gattaran_Homepage__kLUb": "Me",
  "Gattaran_MSGCenter__Kbqd": "Set a specified send time",
  "Gattaran_Feedback__dWQe": "Task Assignee",
  "Gattaran_MSGCenter__GxXJ": "Set",
  "Gattaran_MSGCenter__cEqf": "Please enter",
  "Gattaran_MSGCenter__BZkt": "Send Log",
  "Gattaran_MSGCenter__VINe": "Expand",
  "FoodB_system_AFma_LhIY": "Request",
  "Gattaran_Homepage__GVcy": "Design Resources Download",
  "Gattaran_Feedback__ddlX": "Feedback",
  "Gattaran_Homepage__FxHz": "Got It",
  "Gattaran_Homepage__QaKY": "Time Zone: {{cityname}}",
  "FoodOpB_management_Maximum_quantity_JEJp": "Maximum quantity reached",
  "Gattaran_MSGCenter__rffG": "Reset",
  "Gattaran_Homepage__XxTT": "Guide to Using Gattaran",
  "Gattaran_Feedback__SwBm": "Actions",
  "Gattaran_Homepage__anfP": "Click to view a list of roles corresponding to each feature module.",
  "Gattaran_Feedback__chUi": "Enter a detailed description of the issue, such as when, how to do, what, how often, etc.",
  "Gattaran_Feedback__cEaW": "Module",
  "Gattaran_Homepage__KEfd": "Click options on the main navigation bar, such as Store, Courier, or Data Products, to switch between corresponding subsystems. The left navigation menu in the subsystem displays all subsystem feature modules that you currently have permissions for. Each subsystem provides a feature overview page, where you can view a full list of subsystem features, get a list of related roles, and quickly request permissions.",
  "FoodB_I_Exit_sfrY": "Sign Out",
  "Gattaran_Homepage__AHIW": "Product Design Manual",
  "Gattaran_Feedback__SHVh": "Task Assignee",
  "Gattaran_Feedback_JvYQ_JyXO": "I'd like to change the store/signatory information",
  "Gattaran_V2_LuUu_Rpls": "Rejected",
  "Gattaran_MSGCenter__myYJ": "Download Template",
  "sailing.dilu.SysBasicConfig": "System Settings",
  "Gattaran_MSGCenter__XIYn": "Message Configuration",
  "Gattaran_Feedback__Govn": "Region of Issue Occurrence",
  "Gattaran_V2_NzFp_yjYY": "View Details",
  "Gattaran_MSGCenter__FtSp": "Add",
  "soda-m-i18n---您当前的网络环境不太好，请更换至网络稳定的环境再次尝试": "Your current network environment is not very good, please try again to change to a stable network environment",
  "Gattaran_Feedback__fnhs": "Processing Conclusion",
  "Gattaran_Homepage__OukI": "Use Old Version",
  "Gattaran_Feedback__ykZG": "Up to 5 images can be uploaded",
  "FoodB_system_MBBl_SUqv": "Bug",
  "Gattaran_Homepage__SbiO": "Products have been reclassified according to their business type. Familiarize yourself with the new classification method and find out more helpful features.",
  "Gattaran_MSGCenter__kiOa": "Business",
  "Gattaran_Feedback_BnWd_kcBd": "I found a text error",
  "Gattaran_Feedback_Uxer_NPzU": "I don't have access to this feature",
  "Gattaran_MSGCenter__esUP": "Stop this message?",
  "FoodB_202502_iDjM_HZOr": "Please only submit once",
  "Gattaran_0416_aBBV_Ymcw": "Multiline input box",
  "Gattaran_V2_KeYD_zlnO": "Send time must be at or before the start time of the message card’s effective period",
  "Gattaran_Feedback__mVws": "Upload",
  "FoodOpC_Notifications_Time_zone_YaBE": "time zone",
  "Gattaran_MSGCenter__Xxgq": "Cancel",
  "FoodOpB_copy_The_interval_zsXr": "Time between orders cannot exceed {{day}} day(s)",
  "Gattaran_Homepage__Tchu": "Recently Visited",
  "Gattaran_MSGCenter__pLZR": "Daily",
  "Gattaran_Homepage__XQjL": "Request Permissions",
  "Gattaran_MSGCenter__xOWq": "Message content",
  "Gattaran_V2_yYKm_eBiS": "Pop-up message card",
  "Gattaran_V2_lotK_apqj": "Up to",
  "Gattaran_MSGCenter__HxEk": "All",
  "Gattaran_MSGCenter__ehbg": "Time Zone Selection",
  "Gattaran_V2_omYw_wLSK": "Content images (up to 4 images)",
  "Gattaran_Homepage__PTEn": "Next",
  "Gattaran_MSGCenter__eNOL": "Please enter",
  "FoodC_remind_Unable_to_Wjlz": "Unable to load. Tap to try again",
  "Gattaran_MSGCenter__iWDe": "Basic Settings",
  "Gattaran_MSGCenter__DUmv": "Send immediately",
  "Gattaran_Feedback__SPGu": "Current Processing Status",
  "Gattaran_lowcode_dnHP_Gabp": "Unable to load page. Please click to try again, or contact the platform administrator.",
  "Gattaran_Homepage__lnWD": "Back",
  "Gattaran_MSGCenter__yJJS": "Product Module",
  "Gattaran_MSGCenter__bLAo": "Image (suggested dimensions: 624px*312px)",
  "Gattaran_Homepage__uCVu": "View Guide",
  "Gattaran_Homepage__lXkk": "Set Country, Time Zone, and Language",
  "Gattaran_MSGCenter__vKEM": "Default Version",
  "Gattaran_MSGCenter__oHtl": "Mark All Read",
  "Gattaran_MSGCenter__lbqY": "Actions",
  "Gattaran_Homepage__bYLT": "Home Page",
  "FoodB_system_cYsu_ZWYN": "Action Query",
  "Gattaran_MSGCenter__xBnV": "Issued",
  "Gattaran_Homepage_soPn_KBFC": "Common Module and Page Templates",
  "Gattaran_MSGCenter__XgxF": "Target Group",
  "FoodOpB_Authority2_Role_List_OQWs": "Role List",
  "Gattaran_Feedback__ktgU": "This page link is invalid",
  "Gattaran_Feedback__zzVL": "Page Link of Issue Occurrence",
  "Gattaran_Feedback_tIFD_xuzA": "Product Suggestion",
  "Gattaran_Feedback__adec": "Feedback processing has started, and feedback status was changed to \"Processing\"",
  "Gattaran_MSGCenter__wdfs": "Completed",
  "FoodB_system_EWCs_iStS": "Ticket Type",
  "Gattaran_Feedback__xywA": "Please enter",
  "Gattaran_20240401_SucJ_yXvM": "Question Options",
  "Gattaran_Homepage__qMzz": "or scan the QR code to join the \"Gattaran Online Feedback Group\" via D-Chat",
  "Gattaran_MSGCenter__ypXf": "Send Time",
  "Gattaran_MSGCenter__SGXp": "Delete this message?",
  "Gattaran_MSGCenter__sQlj": "Created by",
  "Gattaran_MSGCenter__wYPN": "Receiving Application",
  "Gattaran_MSGCenter__CUTJ": "Custom {{version_num}}",
  "Gattaran_Feedback__pbpG": "Feedback Details",
  "Gattaran_Feedback__BoaN": "Reason for Feedback",
  "Gattaran_V2_fiBJ_wAfB": "Message Card Effective Period",
  "Gattaran_MSGCenter__qflV": "Please select",
  "Gattaran_Homepage__MtRG": "View Permission(s)",
  "sailing.dilu.newfeedback": "Feedback",
  "Gattaran_0424_HooT_uHlF": "Cancel",
  "Gattaran_MSGCenter__sRnc": "Select creation time",
  "Gattaran_Homepage__aeIE": "Click to View",
  "soda-m-i18n---查询到的数据有点小问题，请再试一次": "There is an issue with data you are querying, try again",
  "Gattaran_Homepage__KisY": "To access this feature, please request the appropriate role permissions based on your position.",
  "Gattaran_20240401_dTUg_cbfD": "Survey Content Configuration",
  "Gattaran_20240401_EwyS_XNBx": "Survey Title",
  "Gattaran_MSGCenter__WOKq": "Collapse",
  "Gattaran_Homepage__rxJe": "Cancel",
  "Gattaran_MSGCenter__fKVx": "Message Title",
  "Gattaran_MSGCenter__jVqk": "Receiving Application",
  "Gattaran_V2_HsHn_NQQR": "Message Card Display Frequency",
  "Gattaran_V2_ghDi_LLbp": "Target group",
  "Gattaran_Feedback__UgYW": "Got It",
  "FoodB_statistics_Refresh_qDDP": "Refresh",
  "Gattaran_MSGCenter__TIzW": "Language Type",
  "Gattaran_MSGCenter__Krud": "Status",
  "Gattaran_MSGCenter__gzaW": "Please select",
  "Gattaran_V2_kzRk_KWRP": "All groups",
  "FoodB_2_Created_successfully_IqRa": "Created successfully!",
  "Gattaran_V2_Lyuv_BCOl": "This period is used by another message card",
  "Gattaran_MSGCenter__tgFp": "Product Module",
  "Gattaran_0424_aMnh_OeRE": "Confirm",
  "FoodC_sales_Not_set_AJmE": "Not Now",
  "Gattaran_20240401_vCtD_sEvO": "Create New Survey",
  "Gattaran_MSGCenter__chmB": "No more messages",
  "Gattaran_Homepage__KYtj": "Language",
  "Gattaran_Homepage__lRUO": "Country",
  "Gattaran_0416_eOIG_voOz": "Add a Question",
  "Gattaran_Homepage__AmGl": "Existing Permission(s)",
  "Gattaran_V2_XkEi_RPoU": "{{num}} time(s) a day",
  "Gattaran_Homepage__BYnh": "No permission",
  "Gattaran_Homepage__Fkve": "The Toolbar allows you to set the country and language, view messages and notifications, and send us your feedback",
  "Gattaran_Feedback__QMDO": "Processing Progress",
  "Gattaran_Auth_fSHw_fDtt": "Request permission now",
  "Gattaran_Feedback__WUQR": "My Feedback",
  "Gattaran_Feedback__NySC": "Feedback Submitted Successfully",
  "common_no": "No",
  "Gattaran_Feedback_hXFJ_wgsq": "Lead management request (suspend, unsuspend, create, edit, etc.)",
  "Gattaran_MSGCenter__jiXX": "Message Type",
  "Gattaran_Homepage__pnNi": "Clicking this icon will bring you back to the home page, where you can quickly access the “Recently Visited” feature, view an overview of the Gattaran system, and quickly request permissions.",
  "Gattaran_MSGCenter__SwjL": "Stop",
  "Gattaran_Auth_BQfS_LpZc": "Give Feedback",
  "Gattaran_MSGCenter__hpmD": "Message Type",
  "FoodOpB_entrance_Learning_Centre_ENzd": "Learning Center",
  "FoodB_modification_Modified_sTAw": "Edited successfully",
  "FoodB_system_QnGW_PNFN": "Copywriting",
  "Gattaran_mgt_Tips_NpAN": "Note",
  "Gattaran_Homepage__oGEC": "Overview",
  "Gattaran_Feedback__GGDd": "Submit Conclusion",
  "Gattaran_Feedback__EeVZ": "Processing Conclusion",
  "FoodB_up250108_muEZ_uUVF": "Copy",
  "Gattaran_20240401_hhVY_xurV": "Please set at least one question",
  "Gattaran_Feedback__dGOG": "Cancel",
  "Gattaran_20240401_FchZ_ipbt": "Basic Information Configuration",
  "Gattaran_MSGCenter__uZZb": "Image",
  "Gattaran_lowcode_xOev_XItQ": "Unable to get page resource. Please click to try again, or contact the platform administrator.",
  "Gattaran_MSGCenter__RtfX": "Enter a description for template management",
  "Gattaran_MSGCenter__oaHw": "Read Messages Count",
  "Gattaran_0416_dvjl_GeNS": "Question {{num}}",
  "Gattaran_notice_dpsU_cOCk": "Deleted",
  "Gattaran_MSGCenter__WGno": "Please select"
}